<router-outlet></router-outlet>
<!-- <app-a2hs-prompt-button *ngIf="a2hsService.showAddToHomeScreen()"></app-a2hs-prompt-button> -->
<!-- <app-ios-prompt-screen *ngIf="a2hsService.showIosInstall()"></app-ios-prompt-screen> -->
<app-ad-block-checker timer="3000"></app-ad-block-checker>
<cookie-consent [displayDelay]="1500"></cookie-consent>